(function () {
  'use strict';

  if (window.rnrMobileNavSearchFixLoaded) return;
  window.rnrMobileNavSearchFixLoaded = true;

  function injectStackingFix() {
    if (document.getElementById('rnr-mobile-nav-search-fix-style')) return;

    var style = document.createElement('style');
    style.id = 'rnr-mobile-nav-search-fix-style';
    style.textContent = [
      '@media (max-width: 989px) {',
      '  .site-header { z-index: 1000; }',
      '  .mobile-drawer { z-index: 1001; }',
      '  .mobile-drawer.is-open { pointer-events: auto; }',
      '  html.lr-mobile-menu-open .shopify-section-group-header-group { position: relative; z-index: 1002; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.defaultPrevented || event.key !== 'Enter' || event.isComposing) return;
      if (!event.target.closest) return;

      var input = event.target.closest('input[type="search"]');
      if (!input || !input.form || !input.value.trim()) return;

      var predictiveSearch = input.closest('predictive-search');
      var selectedSuggestion = predictiveSearch && predictiveSearch.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (selectedSuggestion) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (typeof input.form.requestSubmit === 'function') {
        input.form.requestSubmit();
      } else {
        input.form.submit();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStackingFix, { once: true });
  } else {
    injectStackingFix();
  }
})();